import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import WhyItWorks from './components/WhyItWorks';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#faf7f2]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        <WhyItWorks data-id="element-5" />
        <Testimonials data-id="element-6" />
        <CallToAction data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}